import type { App } from 'vue';
import type { Router } from 'vue-router';
import QLinkImpl from '~/components/qLink';
import QRouter from '~/services/qRouter';

function QRouterPlugin(router: Router) {
  return {
    install(app: App<any>) {
      const qRouterInstance = QRouter.getInstance(router);
      app.component('QLink', QLinkImpl);
      app.use(router);

      app.config.globalProperties.$qRouter = qRouterInstance;
    },
  };
}

export default QRouterPlugin;
